import HOME from "../components/home/index.vue"
import Register from "../components/future/register.vue"
import Authorize from "../components/layout/authorize.vue"
import Logout from "../components/layout/logout.vue"
import ResourcePlaning from "../components/resourcePlaning/index.vue"

export const routes = [
    {
        path: "/",
        redirect: "/index",
    },
    {
        path: "/index",
        name: "home",
        component: HOME,
    },
    {
        path: "/resourcePlaning",
        name: "resourcePlaning",
        component: ResourcePlaning,
    },
    {
        path: "/register",
        name: "register",
        component: Register,
    },
    {
        path: "/oauth/authorize",
        name: "authorize",
        component: Authorize,
    },
    {
        path: "/logout",
        name: "logout",
        component: Logout,
    }
];

